<template>
  <div class="axj_web_bottom">
    <div class="axj_web_bottom_menu">
      <div class="axj_web_bottom_menu_item">
        <label>《爱学界服务协议》《爱学界隐私政策》</label>
      </div>
      <div class="axj_web_bottom_menu_item">
        <label>Copyright © 2020 湖南爱学界信息科技有限公司 湘ICP备2020020184号</label>
      </div>
    </div>
    <div class="axj_web_bottom_send_me">
      <div class="axj_web_bottom_send_me_item">
        <div class="axj_web_bottom_send_me_item_ewm">
          <el-image class="el-image" src="https://img.aixuejie.cn/material/axj_web_bottom_ewm.jpeg" :preview-src-list="['https://img.aixuejie.cn/material/axj_web_bottom_ewm.jpeg']" />
        </div>
        <div class="axj_web_bottom_send_me_item_title">
          <label>公众号</label>
        </div>
      </div>
      <div class="axj_web_bottom_send_me_item">
        <div class="axj_web_bottom_send_me_item_ewm">
         <el-image class="el-image" src="https://img.aixuejie.cn/material/weapp__qrcode.jpg" :preview-src-list="['https://img.aixuejie.cn/material/weapp__qrcode.jpg']" />
        </div>
        <div class="axj_web_bottom_send_me_item_title">
         <label>微信小程序</label>
        </div>
      </div>
      <!-- <div class="axj_web_bottom_send_me_item">
        <div class="axj_web_bottom_send_me_item_ewm">
         <img src="@/assets/image/axj_web/axj_web_bottom_ewm.jpeg">
        </div>
        <div class="axj_web_bottom_send_me_item_title">
         <label>IOS版</label>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "axj_web_bottom"
}
</script>

<style scoped lang="scss">
.axj_web_bottom{
  margin-top: auto;
  //background-color: #dfe4ed;
  background-color: rgba(8,12,41,0.33);
  width: 100%;
  height: 92.05px;
  bottom: 0;
  display: flex;
  .axj_web_bottom_menu{
    display: flex;
    flex-flow: column;
    justify-content: center;
    .axj_web_bottom_menu_item{
      label{
        font-family: Source Han Sans CN;
        font-style: normal;
        font-weight: normal;
        font-size: 11.1px;
        line-height: 22px;
        /* identical to box height */
        color: #484958;
      }
      margin-left: 75px;
    }
    .axj_web_bottom_menu_item:not(:last-child){
    }
    .axj_web_bottom_menu_item:not(:first-child){
      margin-top: 6.575px;
    }
  }
  .axj_web_bottom_send_me{
    display: flex;
    margin-left: auto;
    margin-right: 75px;
    .axj_web_bottom_send_me_item{
      margin-left: 30.75px;
      min-width: 48px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .axj_web_bottom_send_me_item_ewm{
        margin-top: 11.69px;
        width: 48px;
        height: 48px;
        .el-image{
          width: 48px;
          height: 48px;
          border-radius: 5px;
        }
      }
      .axj_web_bottom_send_me_item_title{

        label{
          font-family: Source Code Pro;
          font-style: normal;
          font-weight: normal;
          font-size: 11.1px;
          line-height: 19px;
          /* identical to box height */
          color: #FFFFFF;
        }
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj_web/component/web_bottom/index.vue